export type PartnerRedirectMap = Record<string, Record<string, string>>;

// Source of truth for partner redirect destinations.
// DO NOT modify this data — even typos like "eden-prarie" are intentional.
export const PARTNER_REDIRECTS: PartnerRedirectMap = {
    arrived: {
        default: "/search?center=44.070294%2C-121.349962&zoom=9",
        bend: "/search?center=44.070294%2C-121.349962&zoom=9",
    },
    "bandb-coastal": {
        default: "/search?center=29.574582%2C-81.250751&zoom=10",
        "palm-coast": "/search?center=29.574582%2C-81.250751&zoom=10",
    },
    beachnest: {
        default: "/search",
        "santa-cruz": "/search",
        "moss-landing": "/search",
    },
    "beachside-hilton-head-island": {
        default: "/search?center=32.1475419119034%2C-80.7810980310346&zoom=13",
        "hilton-head-island": "/search?center=32.1475419119034%2C-80.7810980310346&zoom=13",
    },
    blackcomb: {
        default: "/search?center=50.096314872860845%2C-122.9608846934722&zoom=13",
        whistler: "/search?center=50.096314872860845%2C-122.9608846934722&zoom=13",
    },
    "casago-highland-lakes": {
        default: "/search?center=30.455279%2C-97.883195&zoom=9",
        "highland-lakes": "/search?center=30.455279%2C-97.883195&zoom=9",
    },
    "casago-new-smyrna-beach": {
        default: "/search?center=28.984028%2C-80.936768&zoom=10",
        "new-smyrna-beach": "/search?center=28.984028%2C-80.936768&zoom=10",
    },
    "cottage-connection": {
        default: "/search?center=43.818221%2C-69.666337&zoom=11",
        maine: "/search?center=43.818221%2C-69.666337&zoom=11",
    },
    "downtime-vacation-rentals": {
        default: "/search?center=30.346337%2C-85.985137&zoom=10",
        "panama-city-beach": "/search?center=30.346337%2C-85.985137&zoom=10",
    },
    emr: {
        default: "/search",
        "vancouver-island-area": "/search",
        "sunshine-coast": "/search",
        "northern-vancouver-island": "/search",
        "central-vancouver-island": "/search",
        "southern-vancouver-island": "/search",
    },
    kabino: {
        alpine: "/search?lat=43.14034750456228&lng=-111.07023827305984",
        "island-park": "/search",
        default: "/search?lat=44.424222&lng=-111.370972",
    },
    familytimevr: {
        sisters: "/search",
        default: "/search",
    },
    propertyworksvr: {
        boise: "/search",
        default: "/search",
    },
    sistersvr: {
        sisters: "/search",
        default: "/search",
    },
    stoneharbor: {
        default: "/search?center=44.84794415012917%2C-93.45917095008167&zoom=12",
        "eden-prairie": "/search?center=44.84794415012917%2C-93.45917095008167&zoom=12",
        "eden-prarie": "/search?center=44.84794415012917%2C-93.45917095008167&zoom=12",
        kona: "/search?center=19.601627855275055%2C-155.4987823476453&zoom=9",
        indianapolis: "/search?center=39.817020722348346%2C-86.10350010581992&zoom=10",
        denver: "/search?center=39.692344269191366%2C-105.01485783928939&zoom=10",
        "colorado-springs": "/search?center=38.84136825266233%2C-104.78539484284124&zoom=11",
    },
    walz2walz: {
        default: "/search",
        mazomanie: "/search",
    },
    "walkabout-retreat": {
        "summerland-key": "/search?center=24.688059%2C-81.427637&zoom=10",
        default: "/search?center=24.688059%2C-81.427637&zoom=10",
    },
    // #3275 demo partners (try.scouted.com). Hub key = whole footprint (same value as default).
    "panhandle-getaways": {
        default: "/search?center=30.05%2C-85.75&zoom=8",
        panhandle: "/search?center=30.05%2C-85.75&zoom=8",
        "panama-city-beach": "/search?center=30.176%2C-85.806&zoom=12",
        "30a": "/search?center=30.321%2C-86.140&zoom=12",
        destin: "/search?center=30.394%2C-86.496&zoom=12",
        "cape-san-blas": "/search?center=29.750%2C-85.370&zoom=12",
        "fort-walton-beach": "/search?center=30.405%2C-86.619&zoom=12",
        "mexico-beach": "/search?center=29.948%2C-85.420&zoom=12",
        "port-st-joe": "/search?center=29.812%2C-85.303&zoom=12",
        "st-george-island": "/search?center=29.660%2C-84.870&zoom=12",
        sailing: "/search?center=30.05%2C-85.75&zoom=8&q=sailing",
        fishing: "/search?center=30.05%2C-85.75&zoom=8&q=fishing",
        tours: "/search?center=30.05%2C-85.75&zoom=8&q=tours",
    },
    "sea-mountain-vacations": {
        default: "/search?center=33.63%2C-78.92&zoom=9",
        "grand-strand": "/search?center=33.63%2C-78.92&zoom=9",
        "north-myrtle-beach": "/search?center=33.816%2C-78.680&zoom=12",
        "myrtle-beach": "/search?center=33.689%2C-78.887&zoom=12",
        surfside: "/search?center=33.606%2C-78.973&zoom=12",
        "pawleys-island": "/search?center=33.432%2C-79.121&zoom=12",
        "garden-city": "/search?center=33.579%2C-79.003&zoom=12",
        "murrells-inlet": "/search?center=33.551%2C-79.041&zoom=12",
        sailing: "/search?center=33.63%2C-78.92&zoom=9&q=sailing",
        fishing: "/search?center=33.63%2C-78.92&zoom=9&q=fishing",
        tours: "/search?center=33.63%2C-78.92&zoom=9&q=tours",
    },
    // #3312 demo partner; distinct from the real `arrived` portal account above.
    "arrived-now": {
        default: "/search?center=44.85%2C-121.45&zoom=8",
        oregon: "/search?center=44.85%2C-121.45&zoom=8",
        bend: "/search?center=44.058%2C-121.315&zoom=12",
        sunriver: "/search?center=43.874%2C-121.438&zoom=12",
        sisters: "/search?center=44.291%2C-121.549&zoom=12",
        "black-butte-ranch": "/search?center=44.386%2C-121.665&zoom=13",
        "eagle-crest": "/search?center=44.283%2C-121.245&zoom=12",
        "hood-river": "/search?center=45.709%2C-121.512&zoom=12",
        sailing: "/search?center=44.85%2C-121.45&zoom=8&q=sailing",
        fishing: "/search?center=44.85%2C-121.45&zoom=8&q=fishing",
        tours: "/search?center=44.85%2C-121.45&zoom=8&q=tours",
    },
};

export interface PartnerRedirectGeo {
    bounds?: string;
    lat?: number;
    lng?: number;
    zoom?: number;
}

/**
 * Parses the query string portion of a partner redirect URL into geo params.
 * `center` (encoded as `lat%2Clng`) is split into separate lat/lng numbers.
 * Returns `{}` on malformed input rather than throwing.
 */
export const parsePartnerRedirectGeo = (url: string): PartnerRedirectGeo => {
    try {
        const queryString = url.includes("?") ? url.split("?")[1] : "";
        if (!queryString) return {};

        const params = new URLSearchParams(queryString);
        const result: PartnerRedirectGeo = {};

        // Try center first; fall back to explicit lat/lng only if center didn't yield a valid pair
        // (a malformed center must NOT silently leave the redirect with no geo at all).
        let centerProvidedCoords = false;
        const center = params.get("center");
        if (center) {
            const parts = center.split(",");
            if (parts.length === 2) {
                const lat = Number(parts[0]);
                const lng = Number(parts[1]);
                if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
                    result.lat = lat;
                    result.lng = lng;
                    centerProvidedCoords = true;
                }
            }
        }

        if (!centerProvidedCoords) {
            const lat = params.get("lat");
            if (lat !== null) {
                const n = Number(lat);
                if (!Number.isNaN(n)) result.lat = n;
            }

            const lng = params.get("lng");
            if (lng !== null) {
                const n = Number(lng);
                if (!Number.isNaN(n)) result.lng = n;
            }
        }

        const bounds = params.get("bounds");
        if (bounds) result.bounds = bounds;

        const zoom = params.get("zoom");
        if (zoom !== null) {
            const n = Number(zoom);
            if (!Number.isNaN(n)) result.zoom = n;
        }

        return result;
    } catch {
        return {};
    }
};

export interface PartnerRedirectEntry {
    partner: string;
    area: string;
    url: string;
}

/** Flattens PARTNER_REDIRECTS into a list of (partner, area, url) for iteration. */
export const flattenPartnerRedirects = (): PartnerRedirectEntry[] => {
    const entries: PartnerRedirectEntry[] = [];
    for (const [partner, areas] of Object.entries(PARTNER_REDIRECTS)) {
        for (const [area, url] of Object.entries(areas)) {
            entries.push({ partner, area, url });
        }
    }
    return entries;
};
